import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom'; // <- useHistory for v5

export const ViewTextAuthor = () => {
  const { id } = useParams();
  const history = useHistory(); // <- v5 replacement for useNavigate
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const redirectToComposer = async () => {
      try {
        // Find the appropriate text author
        const textAuthorRes = await fetch(`/go/api/v1/text-authors/search/${id}`);
        const textAuthorJson = await textAuthorRes.json();

        const textAuthor = textAuthorJson.hits.hits[0]._source;
        const profileId = textAuthor.profile?.id;

        if (!profileId) {
          console.warn("Text author missing profile.id");
          setLoading(false);
          return;
        }

        // Find the corresponding composer profile to our text-author
        const composerRes = await fetch(`/go/api/v1/composers/search?q=profile.id:${profileId}`);
        const composerJson = await composerRes.json();

        if (!composerJson.hits?.hits?.length) {
          console.warn(`No composer found for profile.id=${profileId}`);
          setLoading(false);
          return;
        }

        const composer = composerJson.hits.hits[0]._source;
        const composerId = composer.id;


        // redirect to the composer page
        history.replace(`/composers/${composerId}`);
      } catch (err) {
        console.error("Error redirecting to composer:", err);
        setLoading(false);
      }
    };

    redirectToComposer();
  }, [id, history]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      {loading ? "Finding matching composer..." : "Redirect failed or not found."}
    </div>
  );
};
